/**
 * BART スコアリング
 * 参考: Lejuez et al. (2002) "Evaluation of a Behavioral Measure of Risk Taking"
 * 指標を忠実に算出するため、破裂試行を平均から除外する（BART 原典の方針）
 */

export interface BalloonTrialRecord {
  pumps: number;
  burst: boolean;
  banked: number; // 保管したポイント（破裂時は 0）
}

export interface BalloonScore {
  totalTrials: number;
  burstCount: number;
  burstRate: number;            // 破裂率 (0–1)
  avgAdjustedPumps: number;     // 破裂を除いた平均ポンプ数（BART 主指標）
  totalBanked: number;          // 累計確定ポイント
}

export function computeBalloonScore(trials: BalloonTrialRecord[]): BalloonScore {
  const totalTrials = trials.length;
  const burstCount = trials.filter((t) => t.burst).length;
  const burstRate = totalTrials > 0 ? burstCount / totalTrials : 0;

  // 破裂しなかった試行だけで平均を取る（BART 原典の「adjusted」指標）
  const successTrials = trials.filter((t) => !t.burst);
  const avgAdjustedPumps =
    successTrials.length > 0
      ? successTrials.reduce((sum, t) => sum + t.pumps, 0) / successTrials.length
      : 0;

  const totalBanked = trials.reduce((sum, t) => sum + t.banked, 0);

  return {
    totalTrials,
    burstCount,
    burstRate,
    avgAdjustedPumps,
    totalBanked,
  };
}
